import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(
        private _auth: AuthService,
        private _route: Router,
        private _alert: AlertService
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        // return true;
        return this._auth.check().then((result) => {
            result = result ? this.userIsAuth() : this.userIsNotAuth();

            return result;
        });
    }

    userIsAuth(): boolean {
        return true;
    }

    userIsNotAuth(): boolean {
        this._route.navigate(['/']);
        this._alert.danger(`Permision denied`);
        return false;
    }
}
